import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TextInputComponent } from './shared/components/atoms/text-input/text-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectComponent } from './shared/components/atoms/select/select.component';
import { MapComponent } from './shared/components/molecules/map/map.component';
import { NavigationComponent } from './shared/components/atoms/navigation/navigation.component';
import { LayoutRegisterClientComponent } from './pages/layout-register-client/layout-register-client.component';
import { PotentialCustomerComponent } from './pages/potential-customer/potential-customer.component';
import { ConfirmLocationComponent } from './pages/confirm-location/confirm-location.component';
import { TaxValidationComponent } from './pages/tax-validation/tax-validation.component';
import { FileUploadComponent } from './pages/file-upload/file-upload.component';
import { ContactInformationComponent } from './pages/contact-information/contact-information.component';
import { FileUploadComponentComponent } from './shared/components/atoms/file-upload-component/file-upload-component.component';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { DragDropDirective } from './directives/drag-drop.directive';
import { TimePickerComponent } from './shared/components/atoms/time-picker/time-picker.component';
import { RegisterCompleteComponent } from './pages/register-complete/register-complete.component';
import { WarningDialogComponent } from './shared/dialogs/warning-dialog/warning-dialog.component';
import { ProgressBarComponent } from './shared/components/molecules/progress-bar/progress-bar.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AwsInterceptor } from './core/interceptors/aws.interceptor';
import { DatePickerComponent } from './shared/components/atoms/date-picker/date-picker.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { Date_Formats } from './shared/components/atoms/date-picker/model/date_format';
import { TextAreaGrowDirective } from './directives/text-area-grow.directive';
import { ToastrModule } from 'ngx-toastr';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { StoreModule } from '@ngrx/store';
import { reducers } from './state/app.state';
import { GoogleMapsModule } from '@angular/google-maps';
import { UploadFileMobileComponent } from './shared/dialogs/upload-file-mobile/upload-file-mobile.component';
import { RadioButtonComponent } from './shared/components/atoms/radio-button/radio-button.component';
import { TermsConditionsDialogComponent } from './shared/dialogs/terms-conditions-dialog/terms-conditions-dialog.component';
import { MapConfirmComponent } from './shared/dialogs/map-confirm/map-confirm.component';
import { VersionComponent } from './shared/components/atoms/version/version.component';

@NgModule({
  declarations: [
    AppComponent,
    TextInputComponent,
    SelectComponent,
    MapComponent,
    NavigationComponent,
    LayoutRegisterClientComponent,
    PotentialCustomerComponent,
    ConfirmLocationComponent,
    TaxValidationComponent,
    FileUploadComponent,
    ContactInformationComponent,
    FileUploadComponentComponent,
    DragDropDirective,
    TimePickerComponent,
    RegisterCompleteComponent,
    WarningDialogComponent,
    ProgressBarComponent,
    DatePickerComponent,
    TextAreaGrowDirective,
    UploadFileMobileComponent,
    RadioButtonComponent,
    TermsConditionsDialogComponent,
    MapConfirmComponent,
    VersionComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    NgxSpinnerModule,
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    ToastrModule.forRoot(),
    PdfViewerModule,
    RecaptchaV3Module,
    StoreModule.forRoot(reducers),
    GoogleMapsModule,
    HttpClientJsonpModule,
  ],
  exports: [NgxSpinnerModule],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: Date_Formats },
    { provide: HTTP_INTERCEPTORS, useClass: AwsInterceptor, multi: true },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
